import React from 'react';
import './styles.scss';

export const Sessions = (): JSX.Element => 
 <div className="ss">
  <div className="ss-header">
   <h2>
    Did you miss anything?<br />
    All sessions are available for<br />
     on-demand streaming!
   </h2>
  </div>
  <div className="ss-wrapper">
  <div className="ss-day">
   <div className="ss-day-title">
    <h3>Replay<br />day <span>#</span>1</h3>
   </div>
   <div className="ss-day-video">
   <iframe
    title="sessionDay1"
    sandbox="allow-same-origin allow-scripts allow-popups"
    src="https://video.igem.org/videos/embed/ea7f36cd-6ab9-4cf5-976c-331fbf07f1b8?title=0&warningTitle=0&peertubeLink=0"
    frameBorder="0"
    allowFullScreen
    />
    </div>
  </div>
  <div className="ss-day">
   <div className="ss-day-title">
    <h3>Replay<br />day <span>#</span>2</h3>
   </div>
   <div className="ss-day-video">
   <iframe
    title="sessionDay2"
    sandbox="allow-same-origin allow-scripts allow-popups"
    src="https://video.igem.org/videos/embed/a1dd4bd9-b965-43e0-854d-5e28329d93aa?title=0&warningTitle=0&peertubeLink=0"
    frameBorder="0"
    allowFullScreen
    />
    </div>
   </div>
  </div>
  </div>
